import generalReducer from './generalReducer';

export * from './generalActionTypes';
export default generalReducer;
